<template>
  <div class="edit-licence">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Серия/ Номер</label>
        <input type="text" class="form-control" v-model="data.number" placeholder required>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Дата выдачи</label>
        <input type="date" class="form-control" v-model="data.issue_date" placeholder required>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Дата окончания срока действия</label>
        <input type="date" class="form-control" v-model="data.expiry_date" placeholder required>
      </div>
    </div>
    <hr class="mb-4" />
  </div>
</template>

<script>
const type = 'driving_licence'

export default {
  name: 'DocumentDrivingLicenceEdit',
  props: ['documentData'],
  data () {
    return {
      data: {
        number: '',
        issue_date: '',
        expiry_date: ''
      }
    }
  },
  mounted () {
    if (this.documentData) {
      this.data = this.documentData
    }
    this.update()
  },
  methods: {
    update () {
      this.$emit('update', {
        type: type,
        data: this.data
      })
    }
  },
  watch: {
    data: {
      handler () {
        this.update()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .edit-licence input {
    margin-bottom: 5px;
  }
  .edit-licence textarea {
    margin-bottom: 5px;
  }
</style>
